import axios from 'axios';
import { API_ROUTES } from '@/constants/api-routes';
import { generateAuthHeaders } from '@/utils/generate-auth-headers';
import { API_URL_V3 } from '@/constants/constants';


/** Per-user UI preference flags. Backend persists these via dotted paths, so
 * sending one flag leaves the others untouched. */
export interface UserPreferences {
  /** Whether the user has dismissed the editor workflow guide banner */
  workflowGuideDismissed?: boolean;
  /** Whether the user has dismissed the item-level edit warning */
  itemLevelEditWarning?: boolean;
  /** Whether the user has dismissed the template-level edit warning */
  templateLevelEditWarning?: boolean;
}

export interface UserOnboardingData {
  /** Legacy field for backwards compatibility */
  editorOnboarded?: boolean;
  /** Map of tour IDs to versions seen */
  completedTours?: Record<string, number>;
  /** Highest release announcement version seen for each module */
  lastSeenReleaseVersionByModule?: Record<string, number>;
  /** ISO timestamp of first login */
  firstLoginAt?: string;
  /** Last app version user has seen */
  lastSeenAppVersion?: string;
  /** Per-user UI preference flags */
  userPreferences?: UserPreferences;
}

/**
 * Get user's onboarding data from the backend
 */
export const getUserOnboardingData = async (): Promise<UserOnboardingData> => {
  const response = await axios.get<UserOnboardingData>(
    `${API_URL_V3}${API_ROUTES.GET_USER_ONBOARDING}`,
    {
      headers: generateAuthHeaders(),
    }
  );
  return response.data;
};

/**
 * Save user's onboarding data to the backend
 */
export const saveUserOnboarding = async (
  payload: Partial<UserOnboardingData>
): Promise<void> => {
  await axios.post(
    `${API_URL_V3}${API_ROUTES.UPDATE_USER_ONBOARDING}`,
    { onboardingData: payload },
    {
      headers: generateAuthHeaders(),
    }
  );
};

